// ABOUTME: The breathing scene at rest: the settled storm sky over a sun scene layer, and the sea and canoe idling.
// ABOUTME: 1A draws it for the whole life of the screen and drives it through the same props as the live scene, so nothing jumps when a round starts or ends.

import BreathSceneArt from './BreathSceneArt';

// x = 1 is the fully cleared base sky, which the storm and sun layers cover; the sea and the canoe idle while no round is armed.
export default function BreathScene(props: Partial<React.ComponentProps<typeof BreathSceneArt>>) {
  return <BreathSceneArt x={1} armed={false} idle intro="rest" swellDur={3} {...props} />;
}
